export const MEMBERSHIP_TIERS = {
  CALENDAR: 'calendar',
  CALENDAR_LOGBOOK_TECHLOG: 'calendar-logbook-techlog',
  FULL_PACKAGE: 'full-package'
};

const FEATURE_ACCESS = {
  calendar: [
    'dashboard',
    'book-aircraft',
    'my-bookings',
    'view-aircraft',
    'pre-flight',
    'profile',
    'airport-lookup',
    'contact'
  ],
  'calendar-logbook-techlog': [
    'dashboard',
    'book-aircraft',
    'my-bookings',
    'view-aircraft',
    'pre-flight',
    'profile',
    'airport-lookup',
    'contact',
    'pilot-logbook',
    'aircraft-tech-log',
    'documents'
  ],
  'full-package': [
    'dashboard',
    'book-aircraft',
    'my-bookings',
    'view-aircraft',
    'pre-flight',
    'profile',
    'airport-lookup',
    'contact',
    'pilot-logbook',
    'aircraft-tech-log',
    'documents',
    'admin',
    'payments'
  ]
};

export function normalizeMembershipTier(value) {
  const tier = String(value || '').trim().toLowerCase();
  const compactTier = tier.replace(/[\s_]+/g, '-');

  const aliases = {
    starter: MEMBERSHIP_TIERS.CALENDAR,
    'calendar-only': MEMBERSHIP_TIERS.CALENDAR,
    'calendar-logbook-tech-log': MEMBERSHIP_TIERS.CALENDAR_LOGBOOK_TECHLOG,
    'calendar-logbook-techlog': MEMBERSHIP_TIERS.CALENDAR_LOGBOOK_TECHLOG,
    'calendar+logbook/tech-log': MEMBERSHIP_TIERS.CALENDAR_LOGBOOK_TECHLOG,
    'calendar+logbook/techlog': MEMBERSHIP_TIERS.CALENDAR_LOGBOOK_TECHLOG,
    'full-package-payments': MEMBERSHIP_TIERS.FULL_PACKAGE,
    full: MEMBERSHIP_TIERS.FULL_PACKAGE,
  };

  if (FEATURE_ACCESS[tier]) return tier;
  if (FEATURE_ACCESS[compactTier]) return compactTier;
  if (aliases[tier]) return aliases[tier];
  if (aliases[compactTier]) return aliases[compactTier];
  return MEMBERSHIP_TIERS.CALENDAR;
}

export function membershipAllows(tier, feature) {
  if (!feature) return true;
  const normalizedTier = normalizeMembershipTier(tier);
  return FEATURE_ACCESS[normalizedTier]?.includes(feature) || false;
}

export function membershipAllowsForRole(
  tier,
  feature,
  role
) {
  const normalizedRole = String(role || '')
    .trim()
    .toLowerCase();

  if (normalizedRole === 'platform_admin') {
    return true;
  }

  if (
    normalizedRole === 'owner' &&
    feature === 'admin'
  ) {
    return true;
  }

  return membershipAllows(tier, feature);
}

export function getMembershipTierLabel(tier) {
  const normalizedTier = normalizeMembershipTier(tier);
  if (normalizedTier === MEMBERSHIP_TIERS.CALENDAR_LOGBOOK_TECHLOG) {
    return 'Calendar + Logbook/Tech Log';
  }
  if (normalizedTier === MEMBERSHIP_TIERS.FULL_PACKAGE) {
    return 'Full Package + Payments';
  }
  return 'Starter';
}
